import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import { memo } from "react";
import FunnelStepNew from "./FunnelStepNew.layout";

const mapStateToProps = (state) => ({
    templates: state.landingPages.templates,
    gamificationTemplates: state.landingPages.gamificationTemplates,
    isLandingPageFormLoading: state.landingPages.isLandingPageFormLoading,

    customSources: state.landingPages.customSources,
    trackers: state.allTrackersState.trackers,
    mmpDetails: state.landingPages.mmpDetails,
    appDetails: state.landingPages.appDetails,
});

const mapDispatchToProps = (dispatch): any => ({});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(memo(FunnelStepNew));
